<div class="auth-page">
  <header class="auth-header">
    <img class="logo" src="/assets/dashboard/logoApp.svg" alt="AutoInsight logo" />

    <div class="title-wrap">
      <button
        *ngIf="showBackButton"
        type="button"
        class="back-button"
        [attr.aria-label]="isMechanicDetailsStep ? 'Back to account details' : 'Back to login'"
        (click)="onBack()"
      >
        &#8592;
      </button>
      <h1>{{ pageTitle }}</h1>
    </div>
  </header>

  <div class="header-divider"></div>

  <form class="auth-form" (ngSubmit)="submit()">
    <h2 class="step-title" *ngIf="isMechanicDetailsStep">Mechanic Details</h2>

    <div class="field-row" *ngIf="showNameField">
      <label for="name">Name</label>
      <input id="name" name="name" type="text" [(ngModel)]="form.name" required />
    </div>

    <div class="field-row" *ngIf="!isMechanicDetailsStep">
      <label for="username">Username</label>
      <input id="username" name="username" type="text" [(ngModel)]="form.username" required />
    </div>

    <div class="field-row" *ngIf="!isMechanicDetailsStep">
      <label for="password">Password</label>
      <input
        id="password"
        name="password"
        type="password"
        [(ngModel)]="form.password"
        required
        [attr.minlength]="isLoginMode ? null : 12"
      />
    </div>

    <div class="field-row" *ngIf="!isLoginMode && !isMechanicDetailsStep">
      <label for="email">Email</label>
      <input id="email" name="email" type="email" [(ngModel)]="form.email" required />
    </div>

    <div class="field-row" *ngIf="showRoleField">
      <label for="role">Register As</label>
      <select id="role" name="role" [(ngModel)]="form.role" (ngModelChange)="onRoleChanged()" required>
        <option value="owner">Owner</option>
        <option value="mechanic">Mechanic</option>
      </select>
    </div>

    <div class="field-row" *ngIf="isMechanicDetailsStep">
      <label for="mechanicPhone">Contact</label>
      <input id="mechanicPhone" name="mechanicPhone" type="text" [(ngModel)]="form.mechanicPhone" required />
    </div>

    <div class="field-row" *ngIf="isMechanicDetailsStep">
      <label for="mechanicLocation">Location</label>
      <input id="mechanicLocation" name="mechanicLocation" type="text" [(ngModel)]="form.mechanicLocation" required />
    </div>

    <p *ngIf="errorMessage" class="message error">{{ errorMessage }}</p>
    <p *ngIf="successMessage" class="message success">{{ successMessage }}</p>

    <button class="action-button" type="submit" [disabled]="loading">
      {{ loading ? 'Please wait...' : submitLabel }}
    </button>

    <button
      *ngIf="isLoginMode"
      class="action-button secondary"
      type="button"
      (click)="goToRegister()"
      [disabled]="loading"
    >
      Register
    </button>
  </form>
</div>
